import { langPath, type Lang } from "@/lib/i18n";

/**
 * Public URL for a post. Posts are slug-keyed (the API exposes `post(slug)`,
 * with no id-based body fetch), so the route is `/posts/<slug>` — no
 * `[id]/[slug]` + canonicalize like the other module detail pages. The slug IS
 * the identity, so a stale slug 404s rather than 301-redirecting. (URL follows
 * the live schema's `post`/`posts` naming — `blog` is legacy; see B18/T4.)
 *
 * Encode the slug segment — backend slugs can carry spaces / diacritics, and a
 * raw space in an href is an invalid URL that breaks RSC navigation + prefetch.
 *
 * `library` builds the in-app (signed-in) `/library/posts/<slug>` link instead of
 * the public one — same rationale as moduleHref: in-app nav stays client-side
 * (no proxy redirect = preserves the SPA feel).
 */
export function postHref(lang: Lang, slug: string | null | undefined, library = false): string {
  const prefix = library ? "/library" : "";
  return langPath(lang, `${prefix}/posts/${encodeURIComponent(slug ?? "")}`);
}
